import _ from 'lodash';
import WebServices from '../WebServices';
import { USERS_ADD, USERS_ADD_ERROR, USERS_ADD_SUCCESS, USERS_FETCH, USERS_FETCH_ERROR, USERS_FETCH_SUCCESS, USER_ROLES_FETCH_SUCCESS, USER_APPROVER_ROLES_FETCH_SUCCESS, USERS_SELECT_USER, USER_FETCH_DETAILS, USER_FETCH_DETAILS_SUCCESS, USER_SAVE_DETAILS, USER_SAVE_DETAILS_ERROR, USER_SAVE_DETAILS_SUCCESS, USERS_DELETE, USERS_DELETE_ERROR, USERS_DELETE_SUCCESS } from './Types';
import { showSnackBarMessage } from './AppInfoActions';


const selectUser = user => (dispatch, getState) => {
    dispatch({ type: USERS_SELECT_USER, payload: user });

    // let webServices = new WebServices();
    dispatch({ type: USER_FETCH_DETAILS });

    // Access a redux store
    const state = getState();

    const userDetails = {
        userId: user.id,
        displayName: user.displayName,
        bun: user.bun,
        permissions: state.users.usersRole.filter((permission) => {
            return permission.userId == user.id
        }),
        approvalRoles: state.users.usersApprovalRole.filter((approvalRole) => {
            return approvalRole.userId == user.id
        })
    }

    dispatch({ type: USER_FETCH_DETAILS_SUCCESS, payload: userDetails });
}

const deleteUser = user => dispatch => {
    dispatch({ type: USERS_DELETE, payload: user });

    let webServices = new WebServices();

    webServices.deleteUser(user.id)
        .then((userDetails) => {
            dispatch(showSnackBarMessage("User Deleted"));
            dispatch({ type: USERS_DELETE_SUCCESS, payload: userDetails });

        })
        .catch((error) => {
            dispatch(showSnackBarMessage("Error Deleting User"));
            dispatch({ type: USERS_DELETE_ERROR, payload: error });
        });
}

const addUser = user => (dispatch, getState) => {
    dispatch({ type: USERS_ADD, payload: user });

    let webServices = new WebServices();
    const { bun } = user;
    let userAlreadyExists = user.bun && getState().users.users.findIndex(user => user.bun.toUpperCase() === bun.toUpperCase()) !== -1;


    webServices.addUser(user.bun)
        .then((userDetails) => {
            userDetails = { ...userDetails, id: userDetails.userId }
            if (userAlreadyExists) {
                dispatch(showSnackBarMessage("User Already Exists"));
            } else {
                dispatch(showSnackBarMessage("User Added"));
                dispatch({ type: USERS_ADD_SUCCESS, payload: userDetails });
            }
            dispatch(selectUser(userDetails));

            // Fetch roles for the newly added user
            import('../WebServices').then(({ default: WebServices }) => {
                const ws = new WebServices();
                ws.getUserDetails(userDetails.userId).then(roleDetails => {
                    if (roleDetails && roleDetails.permissions) {
                        dispatch({ type: USER_ROLES_FETCH_SUCCESS, payload: roleDetails.permissions });
                        // Patch: update selectedUserDetails with new permissions so edit dialog shows roles immediately
                        dispatch({
                            type: 'USER_FETCH_DETAILS_SUCCESS',
                            payload: {
                                ...userDetails,
                                permissions: roleDetails.permissions || [],
                                approvalRoles: roleDetails.approvalRoles || []
                            }
                        });
                    }
                });
            });
        })
        .catch((error) => {
            dispatch(showSnackBarMessage("Error Adding User"));
            dispatch({ type: USERS_ADD_ERROR, payload: error });
        });
}

const saveUserDetails = (userDetails, saveUserDetailsCompleted) => (dispatch, getState) => {

    let webServices = new WebServices();
    dispatch({ type: USER_SAVE_DETAILS });

    webServices.postUserDetails(userDetails)
        .then((userDetails) => {
            dispatch({ type: USER_SAVE_DETAILS_SUCCESS, payload: userDetails });

            // Access a redux store
            const state = getState();
            let AllusersRoles = state.users.usersRole.filter((permission) => {
                return permission.userId != userDetails.userId
            })
            const tempResultPermissions = userDetails.permissions.map((permission) => {
                return { ...permission, bun: userDetails.bun, displayName: userDetails.displayName, userId: userDetails.userId }
            })
            AllusersRoles = [...AllusersRoles, ...tempResultPermissions]
            dispatch({ type: USER_ROLES_FETCH_SUCCESS, payload: AllusersRoles });


            let AllusersApprovarRoles = state.users.usersApprovalRole.filter((approvalRole) => {
                return approvalRole.userId != userDetails.userId
            })
            const tempResultAprover = userDetails.approvalRoles.map((approvalRole) => {
                return { ...approvalRole, userId: userDetails.userId }
            })
            AllusersApprovarRoles = [...AllusersApprovarRoles, ...tempResultAprover]
            dispatch({ type: USER_APPROVER_ROLES_FETCH_SUCCESS, payload: AllusersApprovarRoles });

            saveUserDetailsCompleted();
        })
        .catch((error) => {
            dispatch({ type: USER_SAVE_DETAILS_ERROR, payload: error });
            saveUserDetailsCompleted();
        });

}

const fetchUsers = () => (dispatch) => {

    let webServices = new WebServices();
    dispatch({ type: USERS_FETCH });

    webServices.getUsers()
        .then((result) => {
            dispatch({ type: USERS_FETCH_SUCCESS, payload: result.users });
            dispatch({ type: USER_ROLES_FETCH_SUCCESS, payload: result.usersRoles });
            dispatch({ type: USER_APPROVER_ROLES_FETCH_SUCCESS, payload: result.usersApprovalRole });
            const selectedUser = _.head(result.users);
            dispatch(selectUser(selectedUser));
        })
        .catch((error) => {
            dispatch({ type: USERS_FETCH_ERROR, payload: error });
        });
}

export { fetchUsers, selectUser, addUser, saveUserDetails, deleteUser };

